<template>
  <div class="lottery">
    <van-popup v-model="show" round :style="{width:'88%'}" :close-on-click-overlay="false"  get-container="body">
      <div class="content">
        <van-form 
          :show-error-message="false" 
          validate-trigger="onSubmit" 
          validate-first
          ref="form"
        >
          <van-field
            v-model="prize.prizeName"
            label="奖品类型" 
            label-align="left" 
            input-align="right" 
            readonly 
            right-icon="arrow" 
            class="signup-type top" 
            @click="changePrizeType"
            placeholder="请选择奖品类型"
            :rules="[{ required: true, message: '请选择奖品类型' }]"
          />
          <template v-if="prize.awardType == 'redPack'">
            <van-field 
              label="单个红包金额(元)" 
              label-width="9em"
              label-align="left" 
              input-align="right" 
              class="signup-type" 
              placeholder="请输入红包金额"
              type="number"
              v-model="prize.singleAmount"
              :rules="[{ required: true, message: '请输入红包金额' }]"
              @blur="checkFeeValid('singleAmount')"
            >
            </van-field>
            <van-field 
              label="红包个数(个)" 
              label-align="left" 
              input-align="right" 
              class="signup-type" 
              type="digit"
              :maxlength="4"
              placeholder="请输入红包个数"
              v-model="prize.awardNumber"
              :rules="[{ required: true, message: '请输入红包个数' }]"
              @blur="checkFeeValid('awardNumber')"
            >
            </van-field>
            <van-field 
              label="中奖概率(%)" 
              label-align="left" 
              input-align="right" 
              class="signup-type" 
              type="number"
              placeholder="请输入中奖概率"
              v-model="prize.winProbability"
              :rules="[{ required: true, message: '请输入中奖概率' }]"
              @blur="checkFeeValid('winProbability',3)"
            >
            </van-field>
          </template>
          <template v-else>
            <van-field 
              label="奖品名称" 
              label-align="left" 
              input-align="right" 
              class="signup-type" 
              :maxlength="10"
              placeholder="请输入奖品名称"
              :rules="[{ required: true, message: '请输入奖品名称' }]"
              v-model="prize.awardName"
            />
            <van-field 
              label="奖品份数(份)" 
              label-align="left" 
              input-align="right" 
              class="signup-type"
              type="digit"
              :maxlength="4"
              placeholder="请输入奖品份数"
              v-model="prize.awardNumber"
              :rules="[{ required: true, message: '请输入奖品份数' }]"
              @blur="checkFeeValid('awardNumber')"
            >
            </van-field>
            <van-field 
              label="中奖概率(%)" 
              label-align="left" 
              input-align="right" 
              class="signup-type"
              type="number"
              placeholder="请输入中奖概率"
              v-model="prize.winProbability"
              :rules="[{ required: true, message: '请输入中奖概率' }]"
              @blur="checkFeeValid('winProbability',3)"
            >
            </van-field>
          </template>
          <van-field 
            label-align="left" 
            input-align="right" 
            name="uploader" 
            label="奖品图片上传" 
            v-if="prize.awardType == 'award'"
          >
            <template #input>
              <van-uploader 
                class="uploader" 
                :fileList="prize.bakImg" 
                :max-count="1" 
                preview-size="97" 
                result-type="file"
                :before-read="beforeImgUpload" 
                :after-read=" (e) => uploadImg(e)"
                @delete="(file) => deleteImg(file)"
              />
            </template>
          </van-field>
        </van-form>
        <div class="footer">
          <div class="button cancel" @click="show = false">取消</div>
          <div class="button" @click="onFailed">保存 </div>
        </div>
      </div>
    </van-popup>
    <van-action-sheet 
      v-model="isPrizeType" 
      :actions="prizeType" 
      @select="choicePrize" 
      get-container="body"
      cancel-text="取消"
    />
    <van-popup v-model="isOverlay" :style="{width:'100%'}" :close-on-click-overlay="false" get-container="body">
      <div class="cropper">
        <h5-cropper ref="cropper" :option="option" @getFile="getFile" @canceltailor="canceltailor"></h5-cropper>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { round2Places } from "@/utils/utils";
import H5Cropper  from 'vue-cropper-h5'
export default {
  components: {
    H5Cropper
  },
  props: {
    isAddLotteryPop: {
      type: Boolean,
      default: false
    },
    prize: Object,
    value: Object,
    withdrawConfig: Object,
    isDit: Boolean,
    createdTime: [String, Number]
  },
  computed: {
    show: {
      get() {
        return this.isAddLotteryPop
      },
      set(newVal) {
        this.$emit('update:isAddLotteryPop', newVal)
      }
    },
    isEdit() {
      return this.$route.query.from == 'manager' ? true : false
    },
     // 组件创建方式
    creationMode() {
      return this.$route.query.creationMode != 'new' ? true : false
    }
  },
  data() {
    return {
      isPrizeType: false,
      isOverlay: false,
      prizeType: [{name: '现金红包', type: 'redPack'},{name: '奖品', type: 'award'}],
      option: {
        ceilbutton: true
      },
    }
  },
  methods: {
    changePrizeType() {
      this.isPrizeType = true
    },
    choicePrize(e) {
      // if (this.creationMode) {
      const {openRechargeAndWithdraw, time} = this.withdrawConfig
      let createdTime = this.isDit ? new Date(this.createdTime).getTime() : new Date().getTime()
      const isNewActive = createdTime > new Date(time).getTime()
      if (openRechargeAndWithdraw === 'false' && isNewActive && e.type === 'redPack') {
        this.$dialog.alert({
          title: '提示',
          message: '系统维护中奖品类型不可选择现金红包',
        })
          .then(() => {
            // on confirm
          })
        return
      }
      // }
      this.prize.prizeName = e.name
      this.prize.awardType = e.type
      this.isPrizeType = false
    },
    checkFeeValid(fieldName,digit = 2) {
      const model =  this.prize;
      const fieldValue = model[fieldName];
      if (fieldName == 'singleAmount') {
        if (fieldValue > 1000) {
          model[fieldName]  = 1000
        }else if(fieldValue < 0.3) {
          model[fieldName] = 0.3
        }else {
          model[fieldName] = round2Places(fieldValue)
        }
      }else if (fieldName == 'winProbability' || fieldName == 'awardNumber') {
        model[fieldName] = round2Places(fieldValue,digit)
      }
    },
    beforeImgUpload(file) {
      const acceptTypes = ['image/png', 'image/jpeg', 'image/gif'];
      if (!acceptTypes.includes(file.type)) {
        this.$toast('请上传png、jpg或gif格式图片');
        return false;
      }
      return true;
    },
    uploadImg(e) {
      this.show = false
      this.isOverlay = true
      this.$emit("changFoot", false)
      this.$nextTick(()=> {
        this.$refs.cropper.loadFile(e.file)
      })
      
    },
    getFile(file) {
      this.$emit("changFoot", true)
      this.show = true
      this.isOverlay = false
      let imgList = this.prize.bakImg
      const currentFile = {
        status:'uploading',
        message: '上传中...'
      }
      imgList.push(currentFile)
      this.$api.common.uploadImg(file)
        .then(({data}) => {
          if (data && data[0]) {
            const fileUrl = data[0].fileUrl;
            imgList[0].url = fileUrl
            imgList[0].status = 'done'
            delete imgList[0].status
            delete imgList[0].message
          }
        })
        .catch(err => {
          const currentIndex = this.imgList.indexOf(currentFile);
          if (currentIndex > -1) {
            this.imgList.splice(currentIndex, 1);
          }
      });
    },
    isClone() {
      return this.$route.query.from == 'clone';
    },
    deleteImg(file) {
      let isClone = this.isClone()
      const param = {
        activityId: !isClone ? this.$route.query.activityId || '' : '',
        primaryKey: !isClone ?  this.prize.fieldId && this.prize.fieldId.find(item => item.bakImg).bakImg || '' : '',
        imageUrl: file.url,
        sourceType: 4
      };
      this.$api.common.deleteImg(param)
        .then(() => {
          this.prize.bakImg = []
        });
    },
    canceltailor() {
      this.show = true
      this.isOverlay = false
    },
    onCancel() {
      this.isPrizeType = false
    },
    onFailed() {
      this.$refs.form.validate()
        .then(res => {
          this.$emit('addPrizeSucess', this.prize)
          this.show = false
          // if (this.isEdit) {
          //   this.conserve(this.prize)
          // }else {
          //   this.$emit('addPrizeSucess', this.prize)
          //   this.show = false
          // }
        })
        .catch(err => {
          this.$toast(err[0].message);
        })
    },
    conserve(item) {
      let parmes = {
        activityId: this.value.activityId,
        moduleId: this.value.moduleId,
        activityModuleDetail: []
      }
      let map = ['moduleDetailId','isReplace','moduleGroupCode','fieldId','activityId','moduleId','isNewAdd']
      for(let [key, value] of Object.entries(item)) {
        if (!map.includes(key)) {
            parmes.activityModuleDetail.push({
              moduleDetailCode: key,
              moduleDetailValue: key == 'bakImg' && item[key].length ? item[key][0].url :  value ? value.toString() : '',
              moduleDetailId:  !item.isNewAdd ? this.getModuleDetailId(item.fieldId, key) : '',
              moduleGroupCode: item.moduleGroupCode
            })
        }
      }
      this.$api.luckDraw.edit(parmes).then(res => {
        this.successCallback('保存成功')
        this.$emit('addPrizeSucess', this.prize)
        this.show = false
      })
    },
    getModuleDetailId(fieldId,key) {
      let code = ''
      fieldId.forEach(item => {
        let [[key1,value]] = Object.entries(item)
        if (key1 == key) {
          code = value
        }
      })
      return code
    },
    successCallback(title) {
      this.$toast(title)
      setTimeout(()=> {
        this.bus.$emit('handleSuccess')
      },2000)
    },
  }
}
</script>

<style lang="stylus" scoped>
.content {
  height: 360px;
  .footer {
    box-sizing: border-box
    position absolute;
    left 0
    bottom 0
    padding 0 10px
    height 60px
    width 100%
    display: flex
    align-items: center
    justify-content: space-around
    padding-bottom constant(safe-area-inset-bottom)
    padding-bottom env(safe-area-inset-bottom)
    border-bottom-left-radius: 16px
    border-bottom-right-radius: 16px
    background-color #fff
    .button {
      padding 10px 40px
      border 1px solid $mainTextColor
      border-radius: 8px
      color #fff
      background-color: $mainTextColor
    }
    .cancel {
      color $mainTextColor
      background: #fff;
    }
  }
}
.cropper {
  height: 100vh;
}
</style>